<ui-banner variant="warning" class="margin-bottom-2" *ngIf="hasQuickApply">
    <p>{{ 'forms.applicant-tracker.indeedQuickApplyRequired' | appTranslate }}</p>
</ui-banner>

<form #form="ngForm" autocomplete="off">
    <div role="list">
        <div
            role="listitem"
            class="margin-bottom-5"
            *ngFor="let jobAttachment of jobAttachments; let i = index"
            [attr.aria-label]="
                jobAttachment.name || 'forms.applicant-tracker.screen-reader-only.untitledAttachment'
                    | translate: { number: i + 1 }
            "
        >
            <div class="app-grid centered">
                <mat-form-field class="columns-2">
                    <mat-label>{{ 'forms.applicant-tracker.name' | appTranslate }}</mat-label>
                    <input
                        #documentNameInput="ngModel"
                        [(ngModel)]="jobAttachment.name"
                        type="text"
                        matInput
                        [name]="'jobAttachmentNames-' + i"
                        [attr.name]="'jobAttachmentNames-' + i"
                        placeholder="{{ 'forms.applicant-tracker.fileName' | appTranslate }}"
                        #name="ngModel"
                        required
                    />
                    <mat-error *ngIf="documentNameInput.invalid">{{ documentNameInput.errors | formErrors }}</mat-error>
                </mat-form-field>
                <mat-form-field class="columns-2">
                    <mat-label appRemoveAriaOwns>{{ 'forms.applicant-tracker.documentType' | appTranslate }}</mat-label>
                    <mat-select
                        #documentTypeInput="ngModel"
                        [(ngModel)]="jobAttachment.jobAttachmentTypeId"
                        [name]="'jobAttachmentTypes-' + i"
                        [attr.name]="'jobAttachmentTypes-' + i"
                        placeholder="{{ 'forms.applicant-tracker.attachmentType' | appTranslate }}"
                        required
                    >
                        <mat-option [value]="jobAttachmentTypes.File">
                            {{ 'forms.applicant-tracker.file' | appTranslate }}
                        </mat-option>
                        <mat-option [value]="jobAttachmentTypes.Text">
                            {{ 'forms.applicant-tracker.link' | appTranslate }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="documentTypeInput.invalid">{{ documentTypeInput.errors | formErrors }}</mat-error>
                </mat-form-field>
                <div class="columns-1">
                    <ui-button (click)="removeJobPosting(i)" type="ghost"
                        ><mat-icon svgIcon="close" />{{ 'forms.applicant-tracker.remove' | translate }}</ui-button
                    >
                </div>
            </div>
            <mat-checkbox
                (change)="trackRequired($event)"
                [name]="'isRequired-' + i"
                [(ngModel)]="jobAttachment.isRequired"
            >
                <span>{{ 'forms.applicant-tracker.required' | appTranslate }}</span>
            </mat-checkbox>
        </div>
    </div>
    <ui-button (click)="addJobPosting()" type="link"
        ><mat-icon svgIcon="plus" />{{ 'forms.applicant-tracker.addAttachment' | translate }}</ui-button
    >
</form>
